import { collection, doc, getDocFromServer, getDocsFromServer, query, where } from 'firebase/firestore';
import db from '../firebaseConfig';
import { getCollectionName, VALID_COUNTRY_IDS } from './countryConfig';

/** Read only explicit business dependencies, always within the requested country. */
export const loadProductExportContexts = async (country, rows) => {
  if (!VALID_COUNTRY_IDS.includes(country)) throw new Error('無效的國家');
  if (rows.some(r => (r.country && r.country !== country) || (r.product.country !== undefined && r.product.country !== country))) throw new Error('商品國家不符');
  const [rateDoc, listsSnapshot] = await Promise.all([
    getDocFromServer(doc(db, 'rates', country)),
    getDocsFromServer(query(collection(db, 'livestreamLists'), where('country', '==', country))),
  ]);
  const lists = listsSnapshot.docs.map(d => ({ ...d.data(), id: d.id })).filter(l => l.country === country && !l.archived);
  const productIds = new Set(rows.map(r => r.product.id));
  const memberships = new Map(rows.map(r => [r.product.id, []]));
  for (const list of lists) {
    const items = await getDocsFromServer(collection(db, 'livestreamLists', list.id, 'items'));
    for (const s of items.docs) {
      const item = s.data();
      if (!productIds.has(s.id)) continue;
      if (item.country !== country || item.productId !== s.id) throw new Error('備播關聯國家或商品不符');
      memberships.get(s.id).push({ name: list.name, selectedVariantIds: item.selectedVariantIds || [] });
    }
    const parent = await getDocFromServer(doc(db, 'livestreamLists', list.id));
    if (!parent.exists() || parent.data().country !== country || parent.data().archived || parent.data().revision !== list.revision) throw new Error('備播清單已變更，請重新匯出');
  }
  const relatedCache = new Map();
  const lookup = itemNumber => {
    if (!relatedCache.has(itemNumber)) relatedCache.set(itemNumber, (async () => {
      const s = await getDocsFromServer(query(collection(db, getCollectionName(country)), where('itemNumber', '==', itemNumber)));
      if (!s.docs.length) return { error: '找不到關聯商品' };
      if (s.docs.length !== 1) return { error: '料號對應多件商品，未自動選取' };
      const product = s.docs[0].data();
      if (product.country !== undefined && product.country !== country) throw new Error('關聯商品國家不符');
      return { product: { ...product, id: s.docs[0].id } };
    })());
    return relatedCache.get(itemNumber);
  };
  for (const row of rows) {
    const context = { rates: { data: rateDoc.exists() ? rateDoc.data() : null }, memberships: memberships.get(row.product.id) };
    for (const kind of ['subProducts', 'gifts']) {
      context[kind] = [];
      for (const ref of row.product[kind] || []) context[kind].push(ref.itemNumber ? await lookup(ref.itemNumber) : { error: '缺少關聯料號' });
    }
    row.detailContext = context;
  }
  return rows;
};
